import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import offlineMapsSrc from './images/offline-maps-thumb.avif';

const offlineMaps = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Offline Maps' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Download maps so you always know where you are, even without cell service' }),
  thumbnailImage: offlineMapsSrc.src
});

export default offlineMaps;
